import { useEffect } from 'react'
import { signoutRedirectCallback } from './App'
import { useHistory } from 'react-router-dom'
import LoadingSpinner from './components/LoadingSpinner'
import { useSelector } from 'react-redux';
import store from './redux';
import { storeUser } from './AuthActions';

function SignoutOidc() {
    const history = useHistory();
    //@ts-ignore
    const user = useSelector(state => state.auth.user)
    console.log(user)

    useEffect(() => {
        async function signoutAsync() {
            await signoutRedirectCallback()
            localStorage.removeItem("clientId");
            localStorage.removeItem("issuer");
            localStorage.removeItem("idpType");
            history.push("/");
            localStorage.removeItem('email');
            store.dispatch(storeUser({}));
        }
        signoutAsync()
    }, [])

    return (
        <LoadingSpinner />
    )
}

export default SignoutOidc
